import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

/** Straight line of 5 tiles in facing direction (single column). */
export const LINE_5_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [0, -1],
      [0, -2],
      [0, -3],
      [0, -4],
      [0, -5],
    ],
    [Direction.NE]: [
      [1, -1],
      [2, -2],
      [3, -3],
      [4, -4],
      [5, -5],
    ],
    [Direction.E]: [
      [1, 0],
      [2, 0],
      [3, 0],
      [4, 0],
      [5, 0],
    ],
    [Direction.SE]: [
      [1, 1],
      [2, 2],
      [3, 3],
      [4, 4],
      [5, 5],
    ],
    [Direction.S]: [
      [0, 1],
      [0, 2],
      [0, 3],
      [0, 4],
      [0, 5],
    ],
    [Direction.SW]: [
      [-1, 1],
      [-2, 2],
      [-3, 3],
      [-4, 4],
      [-5, 5],
    ],
    [Direction.W]: [
      [-1, 0],
      [-2, 0],
      [-3, 0],
      [-4, 0],
      [-5, 0],
    ],
    [Direction.NW]: [
      [-1, -1],
      [-2, -2],
      [-3, -3],
      [-4, -4],
      [-5, -5],
    ],
  };
};
